import './index.scss'
var p1_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section1 ul li .section-title').each(function() { //遍历相同样式名的元素
    var p1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p1_max = p1 > p1_max ? p1 : p1_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section1 ul li .section-title').height(p1_max); //给每一个元素设置相同的高度	